import React from "react";
import ReactDOM from "react-dom";
import "./static/style/reset.scss";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { AppProvider } from "./stores/application.store";
//Animation pollyfill
import "web-animations-js";
/**
 * Style imports
 */

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// Register for PWA
serviceWorker.unregister();
